import { render, staticRenderFns } from "./NewRechargeRequest.vue?vue&type=template&id=25b610e6&scoped=true"
import script from "./NewRechargeRequest.vue?vue&type=script&lang=js"
export * from "./NewRechargeRequest.vue?vue&type=script&lang=js"
import style0 from "./NewRechargeRequest.vue?vue&type=style&index=0&id=25b610e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b610e6",
  null
  
)

export default component.exports